import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { TranslocoService, TranslocoModule } from '@jsverse/transloco';
import { LucideAngularModule, User } from 'lucide-angular';
import { TooltipModule } from 'primeng/tooltip';
import { ActionsComponent } from 'src/app/shared/actions/actions.component';
import { CompanyClient } from 'src/app/trip-calculator/models/companyClients';

@Component({
  selector: 'app-client-card',
  standalone: true,
  imports: [ActionsComponent, LucideAngularModule, TranslocoModule, TooltipModule],
  templateUrl: './client-card.component.html',
})
export class ClientCardComponent {
  private translocoService = inject(TranslocoService);

  @Input({ required: true }) client!: CompanyClient;
  @Output() edit = new EventEmitter<CompanyClient>();
  @Output() delete = new EventEmitter<CompanyClient>();

  readonly UserIcon = User;

  get tripCount(): number {
    return this.client._count?.Trip ?? 0;
  }

  get actions() {
    return [
      {
        icon: 'pi pi-pencil',
        label: this.translocoService.translate('companyClientList.edit'),
        action: () => this.edit.emit(this.client),
        testId: 'client.edit.button',
      },
      {
        icon: 'pi pi-trash',
        label: this.translocoService.translate('companyClientList.delete'),
        action: () => this.delete.emit(this.client),
        testId: 'client.delete.button',
      },
    ];
  }

  onCardClick() {
    this.edit.emit(this.client);
  }
}
